import { sutraComponents } from "./Sutra_code/sutraLazyComponents";
import { auth } from "../firebase";
import {
  sutraMaster,
  setQuestion,
  sutraPoints,
  SET_USER_UID,
} from "../Redux/actions";

const FIREBASE_URL =
  "https://vedicmaths-9d086-default-rtdb.asia-southeast1.firebasedatabase.app";

/**
 * Generates a flat array of all [level, chapter, sutraId] triplets
 * from the sutraComponents mapping.
 */
export function getSutraMasterArray() {
  const result = [];
  for (const level in sutraComponents) {
    for (const chapter in sutraComponents[level]) {
      for (const sutraId in sutraComponents[level][chapter]) {
        result.push([level, chapter, sutraId]);
      }
    }
  }
  return result;
}

/**
 * Fetches and restores user progress from Firebase
 */
export const fetchUserProgress = async (dispatch) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not authenticated");

    // --- NEW: Always dispatch UID to Redux ---
    dispatch({ type: SET_USER_UID, payload: user.uid });

    const idToken = await user.getIdToken();
    const response = await fetch(
      `${FIREBASE_URL}/userProgress/${user.uid}.json?auth=${idToken}`
    );

    if (!response.ok) throw new Error("Failed to fetch progress");

    const progress = await response.json();

    if (progress) {
      const sutraArray = getSutraMasterArray();
      const sutraIndex = sutraArray.findIndex(
        ([level, chapter, sutra]) =>
          level === progress.attemptlevel &&
          chapter === progress.attemptchapter &&
          sutra === progress.attemptsutra
      );

      dispatch(sutraMaster(sutraIndex));
      dispatch(setQuestion(progress.attemptquestion));
      if (progress.sutrapoints) {
        dispatch(sutraPoints(progress.sutrapoints));
      }
    }

    return progress;
  } catch (error) {
    console.error("Progress restoration error:", error);
    return null;
  }
};
/**
 * Saves user progress to Firebase with security
 */
export const saveUserProgress = async (progressData) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not authenticated");

    const idToken = await user.getIdToken();

    const response = await fetch(
      `${FIREBASE_URL}/userProgress/${user.uid}.json?auth=${idToken}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...progressData,
          userid: user.uid, // Consistent UID storage
          username: user.displayName || "Guest",
          attemptdate: new Date().toISOString().split("T")[0],
          attemptime: new Date().toLocaleTimeString(),
        }),
      }
    );
    await fetch(
      `${FIREBASE_URL}/sutrahistory/${user.uid}.json?auth=${idToken}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...progressData,
          userid: user.uid,
          username: user.displayName || "Guest",
          attemptdate: new Date().toISOString().split("T")[0],
          attemptime: new Date().toLocaleTimeString(),
        }),
      }
    );
    if (!response.ok) throw new Error("Progress save failed");

    return await response.json();
  } catch (error) {
    console.error("Progress save error:", error);
    throw error;
  }
};
